module.exports = __webpack_public_path__ + "assets/img/BodyLux-w540.b319a3cc.webp";